import { render } from "./DettaglioPratica.vue?vue&type=template&id=2ef8ab3e"
import script from "./DettaglioPratica.vue?vue&type=script&lang=js"
export * from "./DettaglioPratica.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__